import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrintViewComponent } from './print-view/print-view.component';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';
import { PaynowComponent } from './paynow/paynow.component';
import { FullPageModalPopupComponent } from './full-page-modal-popup /full-page-modal-popup.component';
import { PasswordExpiryPopupComponent } from './password-expiry-popup/password-expiry-popup.component';

@NgModule({
    declarations: [PrintViewComponent, ModalPopupComponent, PaynowComponent, FullPageModalPopupComponent, PasswordExpiryPopupComponent],
    imports: [
        CommonModule],
    exports: [PrintViewComponent, ModalPopupComponent, PaynowComponent, FullPageModalPopupComponent, PasswordExpiryPopupComponent],
})
export class ModalPopupModule { }
